import { Timestamp } from '@angular/fire/firestore';
import { IStockTakeFinalFigure } from './stock-take-item.interface';

/**
 * Meta document for chunked finalised figures.
 * Path: .../stock_takes/{stockTakeId}/finalised_meta/_meta
 */
export interface IStockTakeFinalisedMeta {
  chunkDocIds: string[];
  codeToChunkId: Record<string, string>;
  finalisedAt: Timestamp;
  itemCount: number;
  schemaVersion: number;
}

/**
 * Chunk document storing many final figure snapshots keyed by encoded stock code.
 * Path: .../stock_takes/{stockTakeId}/finalised_chunks/{chunkId}
 */
export interface IStockTakeFinalisedChunkDoc {
  entries: Record<string, Omit<IStockTakeFinalFigure, 'id'>>;
  schemaVersion: number;
}

export type IStockTakeFinalFigureStored = Omit<IStockTakeFinalFigure, 'id'>;
